import cx from 'classnames';
import PropTypes from 'prop-types';
import {Button} from '../atoms/Button';
import {Typography} from '../atoms/Typography';
import {EditLineIcon} from '../svg/EditLineIcon';

/*
 * Adds a semi-transparent white overlay to any kind of content (passed as 'children', but are technically siblings)
 * There is an Edit icon (custom copy may be passed in) with a blurred background around the text to help its legibility
 * An optional heading (string) may also be passed. Expectation is that if this content is not gated, only the 'children' will show
 *  */
export const GatedContent = ({
  onClick,
  heading,
  ctaText = 'Edit',
  classNamePrefix,
  dataQaId,
  children,
  isGated = false,
}) => {
  if (!isGated) {
    const gateTrigger = document.getElementById(`gated-content-trigger-${dataQaId}`);
    if (gateTrigger) gateTrigger.style.display = 'none';
  }

  return (
    <>
      {isGated ? (
        <Button
          onClick={onClick}
          variant="transparent"
          data-qa-id={dataQaId}
          id={`gated-content-trigger-${dataQaId}`}
          className={cx('gated-content-button', {
            [`${classNamePrefix}__gated-content-button`]: classNamePrefix,
          })}
        >
          <div className="gated-content__blurred-section">
            {heading ? (
              <Typography variant="header5" className="gated-content__heading">
                {heading}
              </Typography>
            ) : null}
            <Typography variant="paragraph2">
              <EditLineIcon ratio={0.5} /> {ctaText}
            </Typography>
          </div>
          <span className="gated-content__overlay" />
        </Button>
      ) : null}
      {children}
    </>
  );
};

GatedContent.propTypes = {
  onClick: PropTypes.func.isRequired,
  heading: PropTypes.string,
  ctaText: PropTypes.string,
  classNamePrefix: PropTypes.string,
  dataQaId: PropTypes.string,
  children: PropTypes.node.isRequired,
  isGated: PropTypes.bool,
};
